<main
  class="login-page-wrapper"
>
  <section
    class="branding-panel"
  >
    <a
      class="branding-logo-tile"
      routerLink="/login"
    >
      <img
        class="branding-logo-img"
        src="assets/logos/pi-signage-full-logo.svg"
        alt="PI Signage"
      >
    </a>
    <div
      class="branding-content"
    >
      <p
        class="branding-tag"
      >
        Account recovery
      </p>
      <h1
        class="branding-heading"
      >
        Choose a strong new password.
      </h1>
      <p
        class="branding-subtext"
      >
        Complete the secure reset flow and return to your organization workspace.
      </p>
    </div>
  </section>

  <section
    class="login-panel"
  >
    <div
      class="login-card"
    >
      <span
        class="login-welcome"
      >
        Account recovery
      </span>
      <h2
        class="login-title"
      >
        Choose a new password
      </h2>
      <p
        class="login-description"
      >
        Enter and confirm the password you want to use.
      </p>

      <form
        #resetForm="ngForm"
        (ngSubmit)="onSubmit()"
      >
        <div
          class="login-field-group"
        >
          <label
            for="resetPassword"
          >
            New password
          </label>
          <input
            pInputText
            class="login-input"
            id="resetPassword"
            name="password"
            type="password"
            autocomplete="new-password"
            [(ngModel)]="password"
            minlength="8"
            required
          >
        </div>

        <div
          class="login-field-group"
        >
          <label
            for="resetConfirmPassword"
          >
            Confirm password
          </label>
          <input
            pInputText
            class="login-input"
            id="resetConfirmPassword"
            name="confirmPassword"
            type="password"
            autocomplete="new-password"
            [(ngModel)]="confirmPassword"
            minlength="8"
            required
          >
        </div>
        <p
          class="field-help"
        >
          Use 8+ characters with an uppercase letter, number, and symbol.
        </p>

        <p
          *ngIf="errorMessage"
          class="alert error"
          role="alert"
        >
          {{ errorMessage }}
        </p>

        <button
          class="login-btn login-btn-primary"
          type="submit"
          [disabled]="resetForm.invalid || isSubmitting"
        >
          {{ isSubmitting ? 'Updating…' : 'Update password' }}
        </button>
      </form>
    </div>
  </section>
</main>
